import React, { useEffect, useState } from 'react';
import facebook from './assets/facebook.png'
import twitter from './assets/x.png'
import instagram from './assets/instagram.png'
import mainLogo from './assets/logo.png'
import { useNavigate } from 'react-router-dom'
import { LOCAL_STORAGE_TOKEN_KEY } from '../../utils/constants';
import { jwtDecode } from 'jwt-decode';



const Footer = () => {
  const navigate = useNavigate()

  const [user, setUser] = useState(null)

  function decodeData(data) {
    return atob(data); // Base64 encoding
  }

  useEffect(() => {
    const storeToken = window.localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY);
    // Decode the JWT token
    const decodedToken = storeToken ? decodeData(storeToken) : null;
    const userInfo = decodedToken ? jwtDecode(decodedToken) : null;
    if (userInfo) {
      setUser(userInfo?.user)
    }
  }, [setUser])



  return (
    <div className='w-full flex flex-col px-[32px] sm:px-[50px] lg:px-[67px] xl:px-[102px] pt-[8vh] pb-[6vh] lg:pb-[40px]'>
      <img src={mainLogo} alt="" className=' w-[164px] h-[32px]' />
      <div className="mt-[24px]  flex flex-col items-start gap-[12px]">
        <p className="text-[20px] font-extrabold w-[307px] text-ravdeepblue ">
          Register your favorite vendors in minutes
        </p>
        <div className="flex gap-[6px] md:gap-2">
          <button onClick={() => navigate('/signup')} className="bg-ravblue h-[42px] whitespace-nowrap flex-items-center  font-bold text-white px-4 py-2  rounded-[80px] text-[16px]">Register business</button>
        {user==null &&  (<button onClick={() => navigate('/signup')} className="border flex h-[42px] whitespace-nowrap border-black font-medium text-black px-4 py-2 rounded-[80px] text-[16px]">Sign up now</button>)}
        </div>
      </div>
      <div className=' flex flex-col  mt-[32px] gap-[1.125rem] text-[16px] text-ravash  sm:text-[1rem]'>
        <div className='flex flex-col md:flex-row text-[16px] gap-[10px] font-medium md:gap-[30px] leading-[18.9px]'>
          <h1 onClick={() => navigate('/about')} className=' cursor-pointer '>About Us</h1>
          <h1 onClick={() => navigate('/contact')} className=' cursor-pointer'>Contact Us</h1>
          {/* <h1 className=' cursor-pointer'>Team</h1> */}
          <h1 onClick={() => navigate('/site-guidelines')} className=' cursor-pointer'>Site Guidelines</h1>
          <h1 onClick={() => navigate('/privacy-policy')} className=' cursor-pointer'>Privacy Policy</h1>
          <h1 onClick={() => navigate('/terms')} className=' cursor-pointer'>Terms of Use</h1>
        </div>
        <div className="h-[1px] w-full bg-[#000] flex" />
      </div>
      <div className='mt-[32px] md:mt-7  lg:mt-0 gap-[1.125rem] sm:gap-0 justify-between flex flex-col lg:flex-row'>
        <div className='flex  gap-2 md:hidden '>
          <img onClick={() => window.open('https://www.facebook.com/profile.php?id=100084154125517', '_blank')}
            src={facebook} alt="" className=' w-9  h-9  cursor-pointer' />
          <img onClick={() => window.open('https://twitter.com/home', '_blank')} src={twitter} alt="" className=' w-9  h-9 cursor-pointer' />
          <img
            onClick={() => window.open('https://www.instagram.com/rateavendor/?hl=en', '_blank')}
            src={instagram}
            alt="Instagram"
            className="w-9  h-9 cursor-pointer"
          />
        </div>
      </div>
      <div className='flex items-center justify-between mt-0 md:mt-0 lg:mt-8 xl:mt-4'>
        <div className=" text-[14px] flex flex-col md:flex-row   mt-4 md:mt-0 font-[500] ">
          ©{new Date().getFullYear()} Rateavendor. All rights reserved.
          <a
            href="https://www.modenbo.com/about"
            className="text-ravblue hover:underline font-[700] block mt-[0px]"
            target="_blank"
            rel="noopener noreferrer"
          > Powered by Modenbo Technologies
          </a>

        </div>
        <div className=' gap-[1.125rem] sm:gap-0  flex flex-col lg:flex-row'>
          <div className='flex  gap-2 hidden md:flex'>
            <img onClick={() => window.open('https://www.facebook.com/profile.php?id=100084154125517', '_blank')}
              src={facebook} alt="" className=' w-9  h-9  cursor-pointer' />
            <img onClick={() => window.open('https://twitter.com/home', '_blank')} src={twitter} alt="" className=' w-9  h-9 cursor-pointer' />
            <img
              onClick={() => window.open('https://www.instagram.com/rateavendor/?hl=en', '_blank')}
              src={instagram}
              alt="Instagram"
              className="w-9 h-9 cursor-pointer"
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Footer
